import * as tslib_1 from "tslib";
import { Exclude } from 'class-transformer';
export class JournalEntryParameterDto {
    constructor() {
        this.clearCache = false;
    }
    getQueryString() {
        const tokens = [];
        if (!!this.managementCompanyId) {
            tokens.push(`managementCompanyId=${this.managementCompanyId}`);
        }
        if (!!this.communityId) {
            tokens.push(`communityId=${this.communityId}`);
        }
        if (!!this.journalEntryId) {
            tokens.push(`journalEntryId=${this.journalEntryId}`);
        }
        tokens.push(`clearCache=${this.clearCache}`);
        return `?${tokens.join('&')}`;
    }
}
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Boolean)
], JournalEntryParameterDto.prototype, "isDuplicateAction", void 0);
